module.exports = __webpack_public_path__ + "static/media/duplicate-alt.1e479712.svg";